import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ImageUploader from 'react-images-upload';

type IProps = {
  onChange: (a: File[], b: string[]) => void;
  single?: boolean;
  withPreview?: boolean;
  image: string;
};
function MyCustomImageUploader({
  onChange,
  image,
  single = false,
  withPreview = true,
}: IProps) {
  const [displayImage, setDisplayImage] = useState(false);
  const onChangeImage = (a: File[], b: string[]) => {
    onChange(a, b);
    setDisplayImage(true);
  };
  useEffect(() => {
    if (image && image !== '') {
      setDisplayImage(true);
    }
  }, [image]);
  return (
    <Box
      style={{
        width: '100%',
        height: 250,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {displayImage === true && image !== '' ? (
        <Box
          onClick={() => setDisplayImage(false)}
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            overflow: 'auto',
          }}
        >
          <img
            src={image}
            style={{
              width: '66%',
              maxWidth: 275,

              height: 'auto',
            }}
          />
        </Box>
      ) : (
        <ImageUploader
          withIcon={true}
          buttonText='Choose images'
          onChange={onChangeImage}
          withPreview={withPreview}
          imgExtension={['.jpg', '.jpeg', '.gif', '.png', '.gif']}
          singleImage={single}
          fileContainerStyle={{
            padding: 0,
            width: '100%',
            height: 200,
            margin: 0,
          }}
        />
      )}
    </Box>
  );
}

export default MyCustomImageUploader;
